export const BNK_STMT_selectTheBankReducer = {
  BNK_STMT_selectTheBank: (state, action) => {
    state.selectedBankObj = action.payload;
  },
};
